import { ReactElement, useMemo } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import Switch from '@src/sld/components/Switch/Switch';
import RTACRectangle from './RTACRectangle';
import { DataPointWithValue } from '@src/types/DataPoint';

type BreakerStackProps = {
  translateXCoordinate: number;
  translateYCoordinate: number;
  switchLabel?: string;
  breakerLabel: string;
  rtacDataPointsWithValues: DataPointWithValue[];
  rtacPointName: string;
};

function BreakerStack(props: BreakerStackProps): ReactElement {
  const {
    translateXCoordinate,
    translateYCoordinate,
    switchLabel,
    breakerLabel,
  } = props;
  const translate = `translate(${translateXCoordinate}, ${translateYCoordinate})`;

  const rtacValue = useMemo(
    () =>
      props.rtacDataPointsWithValues.find(
        (dp) =>
          dp.pointName === props.rtacPointName &&
          dp.sourceDeviceId === 'rtac_1',
      )?.value,
    [props.rtacDataPointsWithValues, props.rtacPointName],
  );

  const fillColor =
    rtacValue === 0 ? 'green' : rtacValue === 1 ? 'red' : 'grey';

  return (
    <g transform={translate}>
      <VerticalLine
        translateXCoordinate={-112.5}
        translateYCoordinate={712}
        length={10}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />
      {switchLabel && (
        <Switch
          label={switchLabel}
          isClosed={false}
          translateXCoordinate={-112}
          translateYCoordinate={700}
          stroke='green'
        />
      )}

      <RTACRectangle
        label={breakerLabel}
        xCoordinate={-123}
        yCoordinate={723}
        labelXCoordinate={-90}
        labelYCoordinate={735}
        fillColor={fillColor}
        textAnchor='right'
      />

      <VerticalLine
        translateXCoordinate={-113.5}
        translateYCoordinate={744}
        length={15}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />
    </g>
  );
}

export default BreakerStack;
